import React from "react";

interface LoaderProps {
  fullScreen?: boolean;
}

const BAR_DELAYS = ["0s", "0.15s", "0.3s", "0.15s", "0s"];

const Loader = ({ fullScreen = false }: LoaderProps) => {
  return (
    <div style={fullScreen ? styles.fullScreen : styles.inline}>
      <style>{`
        @keyframes jhoom-eq {
          0%, 100% { transform: scaleY(0.25); opacity: 0.5; }
          50%       { transform: scaleY(1);    opacity: 1;   }
        }
      `}</style>
      <div style={styles.bars}>
        {BAR_DELAYS.map((delay, i) => (
          <div key={i} style={{ ...styles.bar, animationDelay: delay }} />
        ))}
      </div>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  fullScreen: {
    minHeight: "100vh",
    width: "100%",
    background: "linear-gradient(135deg, #0d0d1f 0%, #1a1a3e 60%, #0d0d1f 100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inline: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "24px",
  },
  bars: {
    display: "flex",
    alignItems: "flex-end",
    gap: "5px",
    height: "48px",
  },
  bar: {
    width: "7px",
    height: "100%",
    background: "linear-gradient(180deg, #b44fff, #7b2ff7)",
    borderRadius: "4px",
    transformOrigin: "bottom",
    animation: "jhoom-eq 0.9s ease-in-out infinite",
    boxShadow: "0 0 8px rgba(123, 47, 247, 0.7)",
  },
};

export default Loader;
